import { ProjectColorMenuContent } from '@components/ArtBoard/ArtboardToolbar'
import type React from 'react'

import { initialColors } from '@/store/reducers/manager/sagas/initProjectActions/colors'

const colors = initialColors.map((color) => ({ ...color, id: color.hexCode }))

export const StatusColors: React.FC = () => (
  <ProjectColorMenuContent
    colors={colors}
    inheritLabel=""
    locked={false}
    hideManage
  />
)
